(function () {

  if (window.__DL_CART_DRAWER_INIT__) return;

  window.__DL_CART_DRAWER_INIT__ = true;



  /* ── API endpoints (locale-aware) ── */

  const getRouteRoot = () => {

    try { return window.Shopify?.routes?.root || window.routes?.root || "/"; } catch {}

    return "/";

  };



  const apiUrl = (path) => getRouteRoot() + path;



  /* ── Shared state ── */

  const STATE = {

    pending: false,

    intent: null,

    intentUntil: 0,

    warrantyVariantId: 0,

    warrantyKey: "",

    handleCache: {},

    lastCart: null,

    debounceT: null,

    upsellSig: "",

    upsellCache: {},

    rendering: false,

  };



  /* ── Helpers ── */

  const locale = document.documentElement.lang === "en" ? "en-GB" : "fr-FR";



  const getShopCurrency = () => {

    try { return Shopify.currency?.active || window.theme?.currency || "EUR"; } catch {}

    return "EUR";

  };



  const moneyFormat = (cents, currency) => {

    const cur = currency || getShopCurrency();

    try {

      /* narrowSymbol : "$6.90" et non "US$6.90", pour coller au reste du site */
      return new Intl.NumberFormat(locale, { style: "currency", currency: cur, currencyDisplay: "narrowSymbol" }).format((cents || 0) / 100);

    } catch {

      return ((cents || 0) / 100).toFixed(2) + " " + cur;

    }

  };



  const fetchCart = async () => {

    const r = await fetch(apiUrl("cart.js"), { credentials: "same-origin" });

    return r.json();

  };



  const postJson = async (url, payload) => {

    return fetch(url, {

      method: "POST",

      headers: { "Content-Type": "application/json" },

      credentials: "same-origin",

      body: JSON.stringify(payload),

    });

  };



  /* ── Render cart items ourselves from /cart.js data ── */

  const renderCartItems = (cart) => {

    const root = $productsRoot();

    if (!root) return;



    const wid = STATE.warrantyVariantId;

    const items = (cart?.items || []).filter((i) => !wid || i.variant_id !== wid);



    if (!items.length) {

      root.innerHTML = "";

      return;

    }



    root.innerHTML = "";



    items.forEach((item) => {

      const row = document.createElement("div");

      row.className = "dl-cart-item";

      row.dataset.key = item.key;



      /* Image */

      const imgWrap = document.createElement("a");

      imgWrap.href = item.url || "#";

      imgWrap.className = "dl-cart-item__img-wrap";



      const img = document.createElement("img");

      img.className = "dl-cart-item__img";

      img.alt = item.product_title || "";

      img.loading = "lazy";

      img.src = item.image

        ? item.image.replace(/(\.[^.]+)$/, "_180x$1")

        : item.featured_image?.url || "";

      imgWrap.appendChild(img);



      /* Title: spans full width (grid col 2-3) */

      const title = document.createElement("a");

      title.href = item.url || "#";

      title.className = "dl-cart-item__title";

      title.textContent = item.product_title || "";



      /* Info bottom: variant + qty (grid col 2) */

      const infoBottom = document.createElement("div");

      infoBottom.className = "dl-cart-item__info-bottom";



      /* Variant / options */

      if (item.variant_title) {

        const variant = document.createElement("div");

        variant.className = "dl-cart-item__variant";

        variant.textContent = item.variant_title;

        infoBottom.appendChild(variant);

      } else if (item.options_with_values?.length) {

        item.options_with_values.forEach((opt) => {

          if (opt.value === "Default Title") return;

          const line = document.createElement("div");

          line.className = "dl-cart-item__variant";

          line.textContent = `${opt.name}: ${opt.value}`;

          infoBottom.appendChild(line);

        });

      }



      /* Properties (ex: personnalisation) */

      if (item.properties) {

        Object.entries(item.properties).forEach(([k, v]) => {

          if (!v || k.charAt(0) === "_") return;

          const prop = document.createElement("div");

          prop.className = "dl-cart-item__variant";

          prop.textContent = `${k}: ${v}`;

          infoBottom.appendChild(prop);

        });

      }



      /* Quantity selector */

      const qtyWrap = document.createElement("div");

      qtyWrap.className = "dl-cart-item__qty";



      const btnMinus = document.createElement("button");

      btnMinus.type = "button";

      btnMinus.className = "dl-cart-item__qty-btn";

      btnMinus.textContent = "−";

      btnMinus.setAttribute("aria-label", "Diminuer");



      const qtyVal = document.createElement("span");

      qtyVal.className = "dl-cart-item__qty-val";

      qtyVal.textContent = String(item.quantity);



      const btnPlus = document.createElement("button");

      btnPlus.type = "button";

      btnPlus.className = "dl-cart-item__qty-btn";

      btnPlus.textContent = "+";

      btnPlus.setAttribute("aria-label", "Augmenter");



      /* Qty handlers */

      const changeQty = async (newQty) => {

        btnMinus.disabled = true;

        btnPlus.disabled = true;

        qtyWrap.classList.add("is-loading");



        try {

          await postJson(apiUrl("cart/change.js"), { id: item.key, quantity: Math.max(0, newQty) });

          const updated = await fetchCart();

          STATE.lastCart = updated;

          fullRender(updated);

        } catch {

          qtyWrap.classList.remove("is-loading");

          btnMinus.disabled = false;

          btnPlus.disabled = false;

        }

      };



      btnMinus.addEventListener("click", () => changeQty(item.quantity - 1));

      btnPlus.addEventListener("click", () => changeQty(item.quantity + 1));



      qtyWrap.appendChild(btnMinus);

      qtyWrap.appendChild(qtyVal);

      qtyWrap.appendChild(btnPlus);



      infoBottom.appendChild(qtyWrap);



        /* Price */

      const price = document.createElement("div");

      price.className = "dl-cart-item__price";

      price.textContent = moneyFormat(item.final_line_price || 0);



      if (item.original_line_price && item.original_line_price > item.final_line_price) {

        price.innerHTML = `<s class="dl-cart-item__compare">${moneyFormat(item.original_line_price)}</s> ${moneyFormat(item.final_line_price)}`;

      }



      /* Fetch compare_at_price from product data */

      (async () => {

        try {

          const root = getRouteRoot();

          const handle = (item.handle || item.url?.split("/products/")[1]?.split("?")[0] || "").trim();

          if (!handle) return;

          const cacheKey = root + handle;

          if (!STATE.handleCache["_product_" + cacheKey]) {

            const r = await fetch(`${root}products/${handle}.js`, { credentials: "same-origin" });

            if (r.ok) STATE.handleCache["_product_" + cacheKey] = await r.json();

          }

          const product = STATE.handleCache["_product_" + cacheKey];

          if (!product) return;

          const variant = product.variants?.find(v => v.id === item.variant_id);

          if (variant?.compare_at_price && variant.compare_at_price > variant.price) {

                        const compareTotal = Math.round(variant.compare_at_price * item.quantity);



            price.innerHTML = `<s class="dl-cart-item__compare">${moneyFormat(compareTotal)}</s> ${moneyFormat(item.final_line_price)}`;

          }

        } catch {}

      })();



      /* Assemble grid row */

      row.appendChild(imgWrap);

      row.appendChild(title);

      row.appendChild(infoBottom);

      row.appendChild(price);



      root.appendChild(row);

    });

  };



  /* ── Full render: update all sections at once ── */

  const fullRender = (cart) => {

    STATE.rendering = true;

    renderCartItems(cart);

    updateSubtotalUI(cart);
    updateWarrantyLineUI(cart);

    updateDiscountsUI(cart);

    setProgressUI(cart);

    syncEmptyMidCTA(cart);

    syncWarrantyFromCart(cart);

    hideWarrantyLineInDOM();

    renderUpsell(cart);

    /* Release guard after DOM settles */

    requestAnimationFrame(() => { STATE.rendering = false; });

  };



  /* ── Discounts display ── */

  const updateDiscountsUI = (cart) => {

    const el = document.querySelector("#CartDrawer [data-discounts]");

    if (!el) return;



    const discounts = cart?.cart_level_discount_applications || [];

    if (!discounts.length) {

      el.innerHTML = "";

      return;

    }



    const rows = discounts.map((d) =>

      `<div class="cart__discount">${d.title} (-${moneyFormat(d.total_allocated_amount)})</div>`

    ).join("");



    el.innerHTML = `

      <div class="cart__discounts cart__item-sub cart__item-row">

        <div>${document.documentElement.lang === "en" ? "Discounts" : "Réductions"}</div>

        <div class="text-right">${rows}</div>

      </div>`;

  };



  const fetchVariantIdFromHandle = async (handle) => {

    if (!handle) return 0;

    if (STATE.handleCache[handle]) return STATE.handleCache[handle];

    const root = getRouteRoot();

    const r = await fetch(`${root}products/${handle}.js`, { credentials: "same-origin" });

    if (!r.ok) return 0;

    const p = await r.json();

    const id = p?.variants?.[0]?.id ? parseInt(p.variants[0].id, 10) : 0;

    STATE.handleCache[handle] = id;

    return id;

  };



  const cartFindWarranty = (cart, variantId) => {

    if (!variantId || !cart?.items) return { inCart: false, key: "" };

    for (const item of cart.items) {

      if (item?.variant_id === variantId) return { inCart: true, key: item.key };

    }

    return { inCart: false, key: "" };

  };



  /* ── DOM selectors ── */

  const $ = (sel) => document.querySelector(`#CartDrawer ${sel}`);



  const $wrap         = () => $("[data-dl-warranty]");

  const $toggle       = () => $wrap()?.querySelector("[data-dl-warranty-toggle]") || null;

  const getWarrantyHandle = () => ($wrap()?.dataset?.handle || "").trim();



  const $progressRoot = () => $("[data-dl-cart-progress]");

  const $productsRoot = () => $("[data-products]");

  const $emptyMid     = () => $("[data-dl-empty-mid]");

  const $subtotal     = () => $("[data-subtotal]");

  const $inner        = () => $("[data-cart-inner]");

  const $nativeEmpty  = () => $("[data-cart-empty]");

  const $upsell       = () => $("[data-dl-upsell]");

  const $upsellTrack  = () => $("[data-dl-upsell-track]");



  const isIntentActive = () => STATE.intent !== null && Date.now() < STATE.intentUntil;



  /* ── Warranty UI helpers ── */

  const setPendingUI = (pending) => {

    const w = $wrap();

    const t = $toggle();

    if (t) t.disabled = !!pending;

    if (w) w.classList.toggle("is-loading", !!pending);

  };



  const setToggleCheckedSilently = (checked) => {

    const t = $toggle();

    if (!t) return;

    t.dataset.lock = "1";

    t.checked = !!checked;

    setTimeout(() => { delete t.dataset.lock; }, 0);

  };



  /* ── Subtotal ── */

  /* Ligne "garantie" dans les totaux : la garantie est au panier mais sa ligne
     est masquee de la liste d'articles. On l'affiche ici pour que le sous-total
     soit explicable. Montant formate dans la devise du marche. */
  const updateWarrantyLineUI = (cart) => {
    const row = $("[data-dl-warranty-line]");
    if (!row) return;
    const wid  = STATE.warrantyVariantId;
    const item = (cart?.items || []).find((i) => wid && i.variant_id === wid);
    const amountEl = row.querySelector("[data-dl-warranty-line-amount]");
    if (!item) { row.classList.add("hide"); return; }
    row.classList.remove("hide");
    if (amountEl) amountEl.textContent = moneyFormat(item.final_line_price || 0, cart?.currency);
  };

  const updateSubtotalUI = (cart) => {

    const el = $subtotal();

    if (!el) return;

    el.textContent = moneyFormat(cart?.total_price || 0);

  };



  /* ── Real items count (excl. warranty) ── */

  const countRealItemsQty = (cart) => {

    const wid = STATE.warrantyVariantId;

    return (cart?.items || []).reduce((acc, item) => {

      if (wid && item.variant_id === wid) return acc;

      return acc + (item.quantity || 0);

    }, 0);

  };



  /* ── Empty state sync ── */

  const syncEmptyMidCTA = (cart) => {

    const emptyMid    = $emptyMid();

    const productsRoot = $productsRoot();

    const inner       = $inner();

    const nativeEmpty = $nativeEmpty();



    const isEmpty = countRealItemsQty(cart) === 0;



    if (inner)       inner.style.display = "block";

    if (nativeEmpty) nativeEmpty.style.display = "none";

    if (emptyMid)    emptyMid.classList.toggle("hide", !isEmpty);

    if (productsRoot) productsRoot.classList.toggle("hide", isEmpty);



    const pr = $progressRoot();

    if (pr) pr.style.display = isEmpty ? "none" : "";

  };



  /* ── Progress bar ── */

  const setProgressUI = (cart) => {

    const root = $progressRoot();

    if (!root) return;



    const mode            = root.dataset.mode || "amount";

    const thresholdAmount = parseInt(root.dataset.thresholdAmount || "8000", 10);

    const thresholdQty    = parseInt(root.dataset.thresholdQty || "2", 10);

    const textEl          = root.querySelector("[data-dl-cart-progress-text]");

    const fillEl          = root.querySelector("[data-dl-cart-progress-fill]");



    const tplRemaining = (root.dataset.textRemaining || "").trim()

      || (mode === "qty"

        ? "Encore {{qty}} article(s) pour livraison gratuite"

        : "Encore {{amount}} pour livraison gratuite");



    const tplReached = (root.dataset.textReached || "").trim()

      || "Livraison gratuite 🎉";



    const wid   = STATE.warrantyVariantId;

    const items = (cart?.items || []).filter((i) => !wid || i.variant_id !== wid);



    let current, threshold, msg;



    if (mode === "qty") {

      current   = items.reduce((s, i) => s + (i.quantity || 0), 0);

      threshold = Math.max(1, thresholdQty);

      const remaining = Math.max(0, threshold - current);

      msg = remaining > 0

        ? tplRemaining.replaceAll("{{qty}}", String(remaining))

        : tplReached;

    } else {

      /* on compte TOUT le panier, garantie incluse si elle est cochee :
         c'est la base utilisee par Shopify pour le seuil de livraison offerte */
      current   = cart?.total_price || 0;

      threshold = Math.max(1, thresholdAmount);

      const remaining = Math.max(0, threshold - current);

      msg = remaining > 0

        ? tplRemaining.replaceAll("{{amount}}", moneyFormat(remaining))

        : tplReached;

    }



    const pct = Math.max(0, Math.min(100, Math.round((current / threshold) * 100)));

    if (fillEl) fillEl.style.width = pct + "%";

    if (textEl) textEl.textContent = msg;

    root.classList.toggle("is-reached", pct >= 100);

  };



  /* ── Hide warranty line in product list ── */

  const hideWarrantyLineInDOM = () => {

    if (!STATE.warrantyKey) return;

    const root = $productsRoot();

    if (!root) return;



    const escaped = CSS.escape(STATE.warrantyKey);

    const el = root.querySelector(`[data-key="${escaped}"]`)

            || root.querySelector(`[data-line-item-key="${escaped}"]`);

    if (el) el.style.display = "none";

  };



  /* ── Warranty init ── */

  const ensureWarrantyIds = async () => {
    const handle = getWarrantyHandle();
    /* 1) try via handle fetch (locale-aware) */
    let id = handle ? await fetchVariantIdFromHandle(handle) : 0;
    /* 2) fallback : direct from data-variant-id attribute (no fetch needed) */
    if (!id) {
      const raw = ($wrap()?.dataset?.variantId || "").trim();
      const parsed = parseInt(raw, 10);
      if (parsed && parsed > 0) id = parsed;
    }
    /* 3) last fallback : try without route prefix in case Shopify.routes.root is misconfigured */
    if (!id && handle) {
      try {
        const r = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
        if (r.ok) { const p = await r.json(); id = p?.variants?.[0]?.id ? parseInt(p.variants[0].id, 10) : 0; }
      } catch {}
    }
    STATE.warrantyVariantId = id;
    if (!id) console.warn("[DL] warranty variant id resolution failed (handle=", handle, ", data-variant-id=", $wrap()?.dataset?.variantId, ")");
    return id;
  };



  const syncWarrantyFromCart = (cart) => {

    if (STATE.pending) return;

    const t = $toggle();

    if (!t) return;



    const found = cartFindWarranty(cart, STATE.warrantyVariantId);

    STATE.warrantyKey = found.key || "";



    if (isIntentActive()) {

      if (found.inCart === STATE.intent) {

        STATE.intent = null;

        STATE.intentUntil = 0;

      } else {

        hideWarrantyLineInDOM();

        return;

      }

    }



    setToggleCheckedSilently(found.inCart);

    hideWarrantyLineInDOM();

  };



  const addWarranty    = async () => postJson(apiUrl("cart/add.js"), { id: STATE.warrantyVariantId, quantity: 1 });

  const removeWarranty = async () => {

    if (!STATE.warrantyKey) {

      const cart  = await fetchCart();

      const found = cartFindWarranty(cart, STATE.warrantyVariantId);

      STATE.warrantyKey = found.key || "";

      if (!found.inCart) return;

    }

    await postJson(apiUrl("cart/change.js"), { id: STATE.warrantyKey, quantity: 0 });

  };



  /* ── Warranty toggle handler ── */

  const handleToggle = async (checked) => {

    if (STATE.pending || !STATE.warrantyVariantId) return;



    STATE.intent      = !!checked;

    STATE.intentUntil = Date.now() + 1200;

    STATE.pending     = true;



    setPendingUI(true);

    setToggleCheckedSilently(checked);



    try {

      if (checked) await addWarranty();

      else         await removeWarranty();



      const updated  = await fetchCart();

      STATE.lastCart = updated;



      fullRender(updated);

    } catch {

      STATE.intent      = null;

      STATE.intentUntil = 0;



      if (STATE.lastCart) {

        fullRender(STATE.lastCart);

      }

    }



    STATE.pending = false;

    setPendingUI(false);

  };



  const bindWarranty = (cart) => {

    const t = $toggle();

    const w = $wrap();

    if (!w || !t) return;



    const found = cartFindWarranty(cart, STATE.warrantyVariantId);

    STATE.warrantyKey = found.key || "";
    /* Auto-add warranty once per session — only if variant id resolved */
    const realQty = countRealItemsQty(cart);
    if (!found.inCart && realQty > 0 && !window.__DL_WARRANTY_DEFAULT_DONE__ && STATE.warrantyVariantId > 0) {
      window.__DL_WARRANTY_DEFAULT_DONE__ = true;
      handleToggle(true);
      return;
    }



    syncWarrantyFromCart(cart);



    if (t.dataset.bound === "1") return;

    t.dataset.bound = "1";

    t.addEventListener("change", () => {

      if (t.dataset.lock === "1") return;

      handleToggle(!!t.checked);

    });

  };



  /* =========================================

     UPSELL

  ========================================= */



  const cartSignature = (cart) => {

    const wid = STATE.warrantyVariantId;

    const items = (cart?.items || [])

      .filter((i) => !wid || i.variant_id !== wid)

      .map((i) => `${i.product_id}:${i.variant_id}:${i.quantity}`)

      .sort()

      .join("|");

    return `${document.documentElement.lang || "fr"}::${items}`;

  };



  const fetchCollectionProducts = async (handle) => {

    if (!handle) return [];

    const root = getRouteRoot();

    const cacheKey = root + handle;

    if (STATE.upsellCache[cacheKey]) return STATE.upsellCache[cacheKey];



    const url = `${root}collections/${encodeURIComponent(handle)}/products.json?limit=50`;

    const r   = await fetch(url, { credentials: "same-origin" });

    if (!r.ok) return [];



    const data     = await r.json();

    const products = Array.isArray(data?.products) ? data.products : [];

    STATE.upsellCache[cacheKey] = products;

    return products;

  };



  const pickUpsellProducts = (products, cart) => {

    const upsell = $upsell();

    if (!upsell) return [];



    const limit = parseInt(upsell.dataset.limit || "4", 10);

    const wid   = STATE.warrantyVariantId;



    const inCartProductIds = new Set(

      (cart?.items || []).filter((i) => !wid || i.variant_id !== wid).map((i) => i.product_id)

    );



    const eligible = products.filter((p) => !inCartProductIds.has(p.id) && p.available !== false);



    /* Stable pseudo-random shuffle seeded from cart signature */

    const sig = cartSignature(cart);

    let seed  = 0;

    for (let i = 0; i < sig.length; i++) seed = (seed * 31 + sig.charCodeAt(i)) >>> 0;

    const rand = () => {

      seed ^= seed << 13; seed >>>= 0;

      seed ^= seed >> 17; seed >>>= 0;

      seed ^= seed << 5;  seed >>>= 0;

      return (seed >>> 0) / 4294967296;

    };



    return eligible.slice().sort(() => rand() - 0.5).slice(0, Math.max(0, limit));

  };



  const buildVariantSelect = (product) => {

    const optionNames = (product?.options || []).map((o) => (o?.name || "").toLowerCase());

    let optIndex = optionNames.findIndex((n) => n.includes("couleur") || n.includes("color"));

    if (optIndex < 0) optIndex = 0;



    const select  = document.createElement("select");

    select.className = "dl-upsell-select";

    select.setAttribute("aria-label", "Variant");



    (product?.variants || []).filter((v) => v.available !== false).forEach((v) => {

      const label = Array.isArray(v.options) ? (v.options[optIndex] || v.title) : v.title;

      const opt   = document.createElement("option");

      opt.value       = String(v.id);

      opt.textContent = label;

      select.appendChild(opt);

    });



    return select;

  };



  /* ── Arrows: created once inside existing .wrap ── */

    const ensureUpsellArrows = () => { /* deprecated — new upsell has no carousel */ };




  /* ── Render upsell cards ── */

    const renderUpsell = async (cart) => {
    const upsell = $upsell();
    const list = upsell?.querySelector("[data-dl-upsell-list]");
    if (!upsell || !list) return;

    if (countRealItemsQty(cart) <= 0) {
      upsell.classList.add("hide");
      list.innerHTML = "";
      STATE.upsellSig = "";
      return;
    }

    const sig = cartSignature(cart);
    if (STATE.upsellSig === sig) return;
    STATE.upsellSig = sig;

    const bagCol = (upsell.dataset.collectionBag || "").trim();
    const accCol = (upsell.dataset.collectionAcc || "").trim();
    const locale = upsell.dataset.locale || "fr";

    const [bags, accs] = await Promise.all([
      fetchCollectionProducts(bagCol),
      fetchCollectionProducts(accCol),
    ]);

    const wid = STATE.warrantyVariantId;
    const inCart = new Set((cart?.items || []).filter((i) => !wid || i.variant_id !== wid).map((i) => i.product_id));

    const pickOne = (products, salt) => {
      const eligible = products.filter((p) => !inCart.has(p.id) && p.available !== false);
      if (!eligible.length) return null;
      let seed = 0;
      const s = sig + String(salt);
      for (let i = 0; i < s.length; i++) seed = (seed * 31 + s.charCodeAt(i)) >>> 0;
      seed ^= seed << 13; seed >>>= 0;
      seed ^= seed >> 17; seed >>>= 0;
      seed ^= seed << 5;  seed >>>= 0;
      const r = (seed >>> 0) / 4294967296;
      return eligible[Math.floor(r * eligible.length)];
    };

    const picks = [pickOne(bags, "bag"), pickOne(accs, "acc")].filter(Boolean);
    if (!picks.length) { upsell.classList.add("hide"); list.innerHTML = ""; return; }

    upsell.classList.remove("hide");
    list.innerHTML = "";
    picks.forEach((p) => list.appendChild(buildUpsellRow(p, locale)));
  };

  const buildUpsellRow = (p, locale) => {
    const row = document.createElement("div");
    row.className = "dl-upsell-row";

    const img = document.createElement("img");
    img.className = "dl-upsell-img";
    img.loading = "lazy";
    img.alt = p.title || "";
    const imgSrc = p?.images?.[0]?.src || p?.image?.src || "";
    if (imgSrc) img.src = imgSrc;

    const body = document.createElement("div");
    body.className = "dl-upsell-body";

    const cleanTitle = (p.title || "").split("|")[0].trim();
    const price = p?.variants?.[0]?.price
      ? moneyFormat(Math.round(parseFloat(p.variants[0].price) * 100))
      : "";

    const titleRow = document.createElement("div");
    titleRow.className = "dl-upsell-title-row";
    titleRow.textContent = price ? `${cleanTitle} — ${price}` : cleanTitle;

    const meta = document.createElement("div");
    meta.className = "dl-upsell-meta";

    const availableVariants = (p?.variants || []).filter((v) => v.available !== false);
    let selectedVariantId = availableVariants[0]?.id || 0;
    let getVid = () => selectedVariantId;

    if (availableVariants.length > 1) {
      const select = buildVariantSelect(p);
      select.classList.add("dl-upsell-variant");
      select.value = String(availableVariants[0].id);
      getVid = () => parseInt(select.value, 10) || selectedVariantId;
      meta.appendChild(select);
    } else {
      const vtitle = availableVariants[0]?.title || "";
      if (vtitle && vtitle !== "Default Title") {
        const span = document.createElement("span");
        span.className = "dl-upsell-variant-label";
        span.textContent = vtitle;
        meta.appendChild(span);
      }
    }

    body.appendChild(titleRow);
    if (meta.childNodes.length) body.appendChild(meta);

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "dl-upsell-add-icon";
    btn.setAttribute("aria-label", locale === "fr" ? "Ajouter au panier" : "Add to cart");
    btn.textContent = "+";

    btn.addEventListener("click", async () => {
      const vid = getVid();
      if (!vid) return;
      btn.disabled = true;
      row.classList.add("is-loading");
      try {
        await postJson(apiUrl("cart/add.js"), { id: vid, quantity: 1 });
        const updated = await fetchCart();
        STATE.lastCart = updated;
        fullRender(updated);
      } finally {
        btn.disabled = false;
        row.classList.remove("is-loading");
      }
    });

    row.appendChild(img);
    row.appendChild(body);
    row.appendChild(btn);
    return row;
  };




  /* =========================================

     INIT

  ========================================= */

  const init = async () => {

    if (!document.getElementById("CartDrawer")) return;



    await ensureWarrantyIds();



    const cart     = await fetchCart();

    STATE.lastCart = cart;



    fullRender(cart);

    bindWarranty(cart);


  };



  const scheduleInit = () => {

    clearTimeout(STATE.debounceT);

    STATE.debounceT = setTimeout(() => {

      if (isIntentActive()) return;

      if (!STATE.pending) {

        init();

      } else if (STATE.lastCart) {

        fullRender(STATE.lastCart);

      }

    }, 150);

  };



  init();

  document.addEventListener("DOMContentLoaded", init);



  const drawer = document.getElementById("CartDrawer");

  if (drawer) {

    const obs = new MutationObserver(() => {

      if (STATE.rendering) return;

      scheduleInit();

    });

    obs.observe(drawer, { childList: true, subtree: true });



    /* Hide Heichat bubble when drawer is open */

    const hideChat = () => {

      const style = getComputedStyle(drawer);

      const isOpen = drawer.classList.contains("is-open") ||

                     drawer.classList.contains("drawer--open") ||

                     drawer.classList.contains("active") ||

                     (style.visibility === "visible" && drawer.offsetWidth > 0);



      document.querySelectorAll("heichat-launcher-shell").forEach((el) => {

        el.style.setProperty("display", isOpen ? "none" : "", "important");

      });

    };



    const chatObs = new MutationObserver(hideChat);
    chatObs.observe(drawer, {
      attributes: true,
      attributeFilter: ["class", "style"],
    });

    /* Polling backup reduit de 500ms a 2000ms pour menager le CPU mobile */
    const chatInterval = setInterval(hideChat, 2000);

    /* Cleanup observers + intervals on page unload (prevent memory leaks on long sessions) */
    window.addEventListener('pagehide', () => {
      try { obs.disconnect(); } catch(e) {}
      try { chatObs.disconnect(); } catch(e) {}
      try { clearInterval(chatInterval); } catch(e) {}
    }, { once: true })

  }

})();